(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-template"]) return;
  try {
    

  const mainEbtn = document.querySelector('.enquire-btn .btn');
  const formEbtn = document.querySelector('.close-modal');

  mainEbtn.addEventListener('click', ()=>{
    const formWrap = document.querySelector('.hidden-form');
    if (formWrap) {
      formWrap.classList.add("active");
      mainEbtn.classList.remove("active"); 
    }
  });
  formEbtn.addEventListener('click', ()=>{
    const formWrap = document.querySelector('.hidden-form');
    if (formWrap) {
      formWrap.classList.remove("active");
      mainEbtn.classList.add("active");
    }
  });

  } catch(e) { console.error(e); }
})();

})();
